<template>
  <figure
    class="_Index_image__wrapper_1YVoz"
    :class="{ 'loaded': type === 'video' }"
    v-lazyload="mediaLoaded"
  >
    <XMediaSpinner class="_Index_image__spinner_2ukk1" />

    <XVideoPlayer
      v-if="type === 'video'"
      class="w-full"
      :class="mediaClass"
      :playsinline="true"
      :options="videoOptions"
    />

    <img
      v-else
      :data-url="media"
      class="_Index_image__item_6LDit"
      :class="mediaClass"
      :alt="alt"
    >
  </figure>
</template>

<script>
import 'video.js/dist/video-js.css'

import { videoPlayer } from 'vue-video-player'

import XMediaSpinner from '@plat/components/MediaSpinner'

export default {
  components: {
    XMediaSpinner,
    'XVideoPlayer': videoPlayer
  },

  props: {
    media: {
      type: String,
      default: ''
    },
    alt: {
      type: String,
      default: 'Image'
    },
    type: {
      type: String,
      default: 'image'
    },
    videoOptions: {
      type: Object,
      default: () => ({})
    },
    mediaClass: {
      type: Array,
      default: () => []
    },
    spinnerClass: {
      type: Array,
      default: () => []
    }
  },

  created () {
    this.$nextTick(() => {
      if (this.type === 'video') {
        this.mediaLoaded()
      }
    })
  },

  methods: {
    mediaLoaded () {
      this.$emit('mediaLoaded')
    }
  }
}
</script>

<style lang="scss">
._Index_image__item_6LDit {
  @apply block w-full opacity-0;

  transition: all .4s ease-in-out;
  visibility: hidden;
}

._Index_image__flip-button_213ZI {
  @apply absolute pin-t pin-r pin-b pin-l z-10 items-center justify-center;

  display: none;
}

._Index_image__wrapper_1YVoz {
  @apply overflow-hidden flex flex-wrap items-center justify-center rounded-t;

  min-height: 100px;

  &.loaded {
    ._Index_image__item_6LDit {
      visibility: visible;
      opacity: 1;
      border: 0;
    }

    ._Index_image__spinner_2ukk1 {
      display: none;
      width: 100%;
    }
  }
}
</style>
